import React from 'react';
import { SharedPageLayout } from '../shared/SharedPageLayout';
import './PlayGamesNow.css';

// Renders the original arcade landing content now moved under /play-games-now.
export function PlayGamesNow() {
  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/play-games-now', label: 'Play games now', accent: true }
  ];

  return (
    <SharedPageLayout
      brand="GIUGGIOLI.NET"
      links={navLinks}
      footerText="Neon Arcade Vault • Powered by Giuggioli.Net"
      footerLink={{ href: '/complete-article-list', label: 'Complete article list' }}
    >
      <div className="play-games-now__content">
        <div className="play-games-now__hero">
          <div className="play-games-now__hero-title">Arcade Nights, Online</div>
          <div className="play-games-now__hero-subtitle">
            I’m genuinely proud to say that my love for 1970s and 1980s video games runs so deep that, as a programmer, I create original games inspired by those classics. I grew up admiring their bold ideas, tight gameplay, and unmistakable style, and I still carry that spirit into every project. That passion pushes me to rebuild the feeling of the golden arcade era while adding my own creative twists. Using only modern web technologies like React and Three JS, I’ve built several games that are ready to play right away. They run fully online, require no downloads, and are free for everyone. Whether you’re on a PC or a smartphone, you can jump in instantly and enjoy the experience. It’s my personal way of honoring the legends of the past while keeping that retro energy alive today.
          </div>
          <div className="play-games-now__hero-actions">
            <a
              href="/killerblock"
              target="_blank"
              rel="noreferrer"
              className="play-games-now__cta play-games-now__cta--hero"
            >
              Drop a Coin
            </a>
          </div>
        </div>

        <div className="play-games-now__header">
          <div>
            <div className="play-games-now__title">Giuggioli’s Neon Originals</div>
            <div className="play-games-now__subtitle">Classic arcade games revived</div>
          </div>
          <div className="play-games-now__badge">Fresh drop</div>
        </div>

        <div className="play-games-now__grid">

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--1943">1943</div>
            <div className="play-games-now__card-title">1943</div>
            <div className="play-games-now__card-text">
              Fly the synthwave squadron, sweep enemy waves, and survive ten missions in this arcade dogfight.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/1943"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--1943"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/1943">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--bank">
              The Bank
            </div>
            <div className="play-games-now__card-title">The Bank</div>
            <div className="play-games-now__card-text">
              Guard the vault, spot the bandits, and protect the crowd in this western arcade shooter.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/the-bank"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--bank"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/the-bank">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--styxxer">
              Styxxer
            </div>
            <div className="play-games-now__card-title">Styxxer</div>
            <div className="play-games-now__card-text">
              Slice neon territory, seal the loop, and dodge the roaming hunters in this Qix-inspired capture run.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/styxxer"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--styxxer"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/styxxer">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--blocks">
              Killer Blocks
            </div>
            <div className="play-games-now__card-title">Killer Blocks</div>
            <div className="play-games-now__card-text">
              Slide the ice blocks, shatter ghost enemies, and survive the neon arena. When the ghosts trigger their ectoplasm power, they can pass through blocks, making every round tougher. Fast rounds, pure 80s rush.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/killerblock"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--blocks"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/killer-blocks">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--jimmyfrog">Jimmy Frog</div>
            <div className="play-games-now__card-title">Jimmy Frog</div>
            <div className="play-games-now__card-text">
              Cross the neon highway and leap across glowing logs in this synthwave Frogger revival. Reach all five lily pads to level up.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/jimmyfrog"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--jimmyfrog"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/jimmy-frog">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--space">Galaxy Assault</div>
            <div className="play-games-now__card-title">Galaxy Assault</div>
            <div className="play-games-now__card-text">
              Defend the neon frontier in a Arcade tribute with shields, mystery ships, and escalating waves.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/space"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--space"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/space">
                READ
              </a>
            </div>
          </div>


          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--4096">4096/2</div>
            <div className="play-games-now__card-title">4096/2</div>
            <div className="play-games-now__card-text">
              Merge neon tiles, chase the synthwave score, and stack your way to the ultimate 4096/2 block.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/4096"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--4096"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/4096">
                READ
              </a>
            </div>
          </div>



          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--ballball">Ball Ball</div>
            <div className="play-games-now__card-title">Ball Ball</div>
            <div className="play-games-now__card-text">
              Chomp neon dots, power up to chase ghosts, and clear every level in this synthwave maze chase.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/ballball"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--ballball"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/ballball">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--bouncingball">Bouncing Ball</div>
            <div className="play-games-now__card-title">Bouncing Ball</div>
            <div className="play-games-now__card-text">
              Deflect the neon ball with your synthwave paddle, smash glowing bricks, and rack up points in this Three.js Breakout revival. Just swipe to move!
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/bouncingball"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--bouncingball"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/bouncing-ball">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--viper">Viper</div>
            <div className="play-games-now__card-title">Viper</div>
            <div className="play-games-now__card-text">
              A synthwave Snake revival with wraparound lanes, glowing bites, and hypnotic arcade pacing.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/viper"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--viper"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/viper">
                READ
              </a>
            </div>
          </div>


          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--spong">Sbong</div>
            <div className="play-games-now__card-title">Sbong</div>
            <div className="play-games-now__card-text">
              Minimalist game action with mouse or touch control, crisp rallies, and an always-ready AI opponent.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/sbong"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--spong"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/sbong">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--crazycars">Crazy Cars</div>
            <div className="play-games-now__card-title">Crazy Cars</div>
            <div className="play-games-now__card-text">
              Drift through a neon highway, dodge incoming traffic, and survive as the road curves harder in this synthwave arcade racer.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/crazycars"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--crazycars"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/crazy-cars">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--numdle">Numdle</div>
            <div className="play-games-now__card-title">Numdle</div>
            <div className="play-games-now__card-text">
              Crack the neon number pattern in six tries, read instant clues, and solve the daily math sequence puzzle.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/numdle"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--numdle"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/numdle">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--synthword">Synthword</div>
            <div className="play-games-now__card-title">Synthword</div>
            <div className="play-games-now__card-text">
              Decode neon five-letter words in six tries with instant keyboard feedback and dual-language arcade style.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/synthword"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--synthword"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/synthword">
                READ
              </a>
            </div>
          </div>


          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--synthword6">Synthword 6 Letters</div>
            <div className="play-games-now__card-title">Synthword 6 Letters</div>
            <div className="play-games-now__card-text">
              Crack neon six-letter words in six tries with bilingual IT/EN dictionaries, tile-by-tile feedback, and full keyboard control.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/synthword6"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--synthword6"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/synthword-6-version">
                READ
              </a>
            </div>
          </div>

          <div className="play-games-now__card">
            <div className="play-games-now__card-art play-games-now__card-art--astroshoot">Astroshoot</div>
            <div className="play-games-now__card-title">Astroshoot</div>
            <div className="play-games-now__card-text">
              Blast and split asteroid fields in a neon clone of Asteroids with continuous synthwave momentum.
            </div>
            <div className="play-games-now__card-actions">
              <a
                href="/astroshoot"
                target="_blank"
                rel="noreferrer"
                className="play-games-now__cta play-games-now__cta--astroshoot"
              >
                PLAY NOW
              </a>
              <a className="play-games-now__cta play-games-now__cta--read" href="/play-games-now/astroshoot">
                READ
              </a>
            </div>
          </div>

        </div>
      </div>
    </SharedPageLayout>
  );
}
